import React from 'react';
import PropTypes from 'prop-types';
import SMReservationBaseView from 'components/dashboard/shared/SMReservationBaseView';
import SMConst from 'lib/SMConst';
import SMReservationHeaderView from 'components/dashboard/shared/SMReservationHeaderView';
import SMReservationNoticeView from 'components/dashboard/shared/SMReservationNoticeView';
import SMReservationFlowView from 'components/dashboard/shared/SMReservationFlowView';
import SMBillingList from 'components/dashboard/shared/SMBillingList';
import SMUReservationActionView from './SMUReservationActionView';
import SMUReservationCancelView from './SMUReservationCancelView';
import SMUReservationUnapprovedView from './SMUReservationUnapprovedView';
import SMUnapprovedReservationRejectView from 'components/dashboard/shared/SMUnapprovedReservationRejectView';
import SMUnapprovedReservationConfirmView from 'components/dashboard/shared/SMUnapprovedReservationConfirmView';
import SMGuestList from 'components/dashboard/shared/SMGuestList';
import SMOReservationInviteView from 'components/dashboard/owners/reservations/SMOReservationInviteView';
import Spinner from 'components/shared/SMMaterialSpinner';
import SMReservationStatusDescriptionView from 'components/dashboard/shared/SMReservationStatusDescriptionView';

class SMUReservationView extends SMReservationBaseView {

  constructor(props) {
    super(props);
    this.state['isUnapprovedViewOpen'] = true;
  }

  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    this.sizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  componentWillReceiveProps(nextProps) {
    let newState = this.state;
    if (this.props.reservation !== nextProps.reservation){
      if (nextProps.reservation == null) {
        newState.display = SMConst.Display.Init;
      }
    }
    if (this.props.display !== nextProps.display){
      newState.display = nextProps.display;
    }
    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    this.sizeToFit();
    if (this.props.shouldShowReview) {
      this.scrollToReview();
    }
  }

  inviteActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMOReservationInviteView reservation={this.props.reservation} delegate={this} />
    );
  }
  dismissCancelModalView(e) {
    e.preventDefault();
  }

  cancelActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMUReservationCancelView reservation={this.props.reservation} delegate={this} />
    );
  }

  confirmUnapprovedReservationActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMUnapprovedReservationConfirmView
        reservation={this.props.reservation}
        isOwner={false}
        delegate={this}
      />
    );
  }

  rejectUnapprovedReservationActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMUnapprovedReservationRejectView
        reservation={this.props.reservation}
        isOwner={false}
        delegate={this}
      />
    );
  }

  reservationDidCancel(data, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.reservationDidCancel === 'function'){
      this.props.delegate.reservationDidCancel(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000001"));
  }

  reservationDidFailToCancel(error, xhr) {
    if(this.props.delegate && typeof this.props.delegate.reservationDidFailToCancel === 'function'){
      this.props.delegate.reservationDidFailToCancel(error, xhr);
    }
    $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
  }


  unapprovedReservationDidConfirm(data, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.unapprovedReservationDidConfirm === 'function'){
      this.props.delegate.unapprovedReservationDidConfirm(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000008"));
  }

  unapprovedReservationDidFailToConfirm(error, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.unapprovedReservationDidFailToConfirm === 'function'){
      this.props.delegate.unapprovedReservationDidFailToConfirm(error, xhr);
    }
    if ( xhr.responseJSON.message ) {
      $("#js-split_view-main").showFailMessage(xhr.responseJSON.message.replace(/\\n/g, '<br />'));
    } else {
      $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
    }
    this.setState({ isUnapprovedViewOpen: false });
  }

  unapprovedReservationDidReject(data, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.unapprovedReservationDidReject === 'function'){
      this.props.delegate.unapprovedReservationDidReject(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000009"));
  }

  unapprovedReservationDidFailToReject(error, xhr) {
    if(this.props.delegate && typeof this.props.delegate.unapprovedReservationDidFailToReject === 'function'){
      this.props.delegate.unapprovedReservationDidFailToReject(error, xhr);
    }
    if ( xhr.responseJSON.message ) {
      $("#js-split_view-main").showFailMessage(xhr.responseJSON.message);
    } else {
      $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
    }
  }

  /* Render */

  renderInit (){
    return (
      <p className="dashboard-maincol__message">{I18n.t("dashboard.text_000014")}</p>
    );
  }

  renderRecieptLink (reservation){
    if (reservation.can_show_receipt) {
      return(<a href={Routes.receipt_dashboard_billing_path(reservation.id)} target="_blank" className="dashboard-title__link">領収書を表示</a>);
    }
    else if (reservation.can_show_billing) {
      return(<a href={Routes.dashboard_billing_path(reservation.id)} target="_blank" className="dashboard-title__link">請求書を表示</a>);
    }
    return null;
  }

  renderPromotions (reservation){
    if (!reservation.promotions) return null;
    let promotions = [], title = null, code = null;
    reservation.promotions.forEach(function(promotion){
      title = promotion.title;
      if (promotion.coupon_type == 0 && promotion.coupon) {
        code = promotion.coupon.code;
      } else {
        code = promotion.external_coupon_code;
      }

      promotions.push(
        <div className="reserve-detail-box">
          <h3 className="reserve-coupon__title"><a href={Routes.promotion_path(promotion.id)}> {title} </a></h3>
          <p className="reserve-coupon__code">クーポンコード</p>
          <p className="reserve-coupon__name"> {code} </p>
        </div>
      );
    });

    return (
      <div>
        <h2 className="dashboard-title mb20 mt50">対象キャンペーン</h2>
        {promotions}
      </div>
    );
  }

  renderLaws (reservation){
    if (!reservation.can_show_receipt) return null;
    return (
      <div>
        <h2 className="dashboard-title mb20 mt40">特定商取引法に基づく表示</h2>
        <p className="dashboard-content mt10 mb50">
          <a href={Routes.tokushoho_owner_path(reservation.owner.username)} target="_blank">こちら</a> からご確認ください
        </p>
      </div>
    );
  }

  renderUnapprovedView (reservation){
    if (!reservation.unapproved_reservation || !this.state.isUnapprovedViewOpen) return null;
    return (
      <SMUReservationUnapprovedView
        reservation={reservation}
        unapproved_reservation={reservation.unapproved_reservation}
        delegate={this} />
    );
  }

  renderDefault (reservation){
    let billingList = [];
    if (reservation.billing) {
      billingList.push(
        <h2 key={reservation.id + "-title"} className="dashboard-title mb20 mt50">
          {I18n.t("dashboard.label_000132")}
          {this.renderRecieptLink(reservation)}
        </h2>
      );
      billingList.push(
        <SMBillingList key={reservation.id} reservation={reservation} isOwner={false} />
      );
    }

    let guestList = [];

    if (reservation.number_of_guests > 0 && reservation.rent_type == SMConst.RentType.Stay && reservation.room.stay_certification_type == SMConst.StayCertificationType.VacationRental) {
      guestList.push(
        <h2 key={reservation.id + "-title"} className="dashboard-title mb20 mt50">{I18n.t("dashboard.label_000601")}</h2>
      );
      guestList.push(
        <p key={reservation.id + "-notice"} className="dashboard-content mb15" dangerouslySetInnerHTML={{__html: I18n.t('dashboard.text_000600_html') }} />
      );
      guestList.push(
        <SMGuestList key={reservation.id} reservation={reservation} delegate={this} />
      );
    }

    let reviewTitleStyle = (reservation.method != SMConst.ReservationMethod.Reservation) ? {display: "none"} : {};

    let reRequestBtn = "";
    if (reservation.status === SMConst.ReservationStatus.Expired) {
      reRequestBtn = (
        <a href={Routes.space_room_reservations_path(reservation.room.space.username, reservation.room.uid)}
           className="button-green pt13 pb13 w220">もう一度予約リクエストを送る
        </a>
      );
    }

    return (
      // NoApproval Viewを表示
      <div>
        {this.renderUnapprovedView(reservation)}
        <SMReservationHeaderView
          isOwner={false}
          reservation={reservation} />
        <SMReservationNoticeView isOwner={false} reservation={reservation} />
        <h2 className="dashboard-title mb20 mt40">{I18n.t("dashboard.label_000133")}</h2>
        <SMReservationFlowView reservation={reservation} isOwner={false} />
        <SMUReservationActionView reservation={reservation} delegate={this} currentUser={this.props.currentUser} />
        <p className="reserve-status-buttonarea">
          {reRequestBtn}
        </p>
        <SMReservationStatusDescriptionView reservation={reservation} isOwner={false} />
        {billingList}
        {guestList}
        {this.renderPromotions(reservation)}
        {this.renderLaws(reservation)}
      </div>

    );
  }

  renderLoading() {
    return (
      <div className="js-empty"><Spinner /></div>
    );
  }

  render() {
    if (!this.props.isCurrentView) return null;
    return (
      <div className="reserve-maincol__right-inner js-scroller" ref="scroller">
        {(()=>{
          switch (this.state.display) {
            case SMConst.Display.Hidden: return null;
            case SMConst.Display.Init: return this.renderInit();
            case SMConst.Display.Loading: return this.renderLoading();
            default: return this.renderDefault(this.props.reservation);
          }
        })()}
      </div>
    );
  }
}
SMUReservationView.propTypes = {
  isCurrentView: PropTypes.bool,
  reservation: PropTypes.object,
  delegate: PropTypes.object,
  rowIndex: PropTypes.number.isRequired,
  shouldShowReview: PropTypes.bool,
};
SMUReservationView.defaultProps = {
  display: SMConst.Display.Visible,
  page: 1,
  perPage: 20,
  shouldShowReview: false,
};
export default SMUReservationView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationView.jsx